<template>
  <div class="page-wrap">

    <!-- Report generation overlay -->
    <transition name="fade">
      <div class="processing-overlay" v-if="generateReport">
        <div class="processing-card">
          <i class="fa fa-circle-o-notch fa-spin"></i>
          <div class="processing-title" v-html="loadingMessage"></div>
        </div>
      </div>
    </transition>

    <enrollmentDetailModal :key="key" v-if="enrollmentDetailModalShow" v-on:closemodal="closeModal"
      :loading-data="loadingData" :has-data="hasData" :show-modal="enrollmentDetailModalShow"
      :enrollment-data="enrollmentData" :index-num="currentIndex" :display-logs="displayLogs"
      @reLoadTable="reTableReload" />

    <canvas id="barcode" class="d-none" style="width:inherit;height:95px"></canvas>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-exchange-alt"></i></div>
          <div>
            <div class="panel-title">
              Store &amp; Forward
              <span class="count-badge" v-if="pagination.total_records > 0">
                {{ pagination.total_records }}
              </span>
            </div>
            <div class="panel-sub">Enrollment transmit queue — track and manage submission status</div>
          </div>
        </div>
        <div class="panel-header-right" v-if="enrollments.length > 0 && !getLoadingData && dateRageType !== 'custom'">
          <download-excel :fetch="fetchData" :header="header" :worksheet="todays_date" name="enrollment-report.xls"
            :fields="json_fields" :before-generate="startDownload" :before-finish="finishDownload">
            <button class="btn-export">
              <i class="fa fa-file-excel-o"></i> Export
            </button>
          </download-excel>
        </div>
      </div>

      <!-- Toolbar (AppType only) -->
      <div class="toolbar" v-if="AppType">

        <!-- Row 1: Search by enrollment no, TCN, name or appointment no -->
        <div class="toolbar-row">
          <div class="search-box">
            <i class="fa fa-search"></i>
            <input type="text" placeholder="Search by enrollment no, TCN, name or appointment no…" v-model="search_text"
              @keypress.enter="search()" />
            <button v-if="search_text" class="search-clear" @click="search_text = ''; search()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <button class="btn-search" @click="search()">
            <i class="fa fa-search"></i> Search
          </button>
        </div>

        <!-- Row 2: Filters -->
        <div class="toolbar-row toolbar-filters">

          <!-- Year (non-client) -->
          <select class="filter-select" style="
    width: 80px;" v-if="!currentUser.u.is_client" v-model="dateRageYear" @change="changeYear()">
            <option v-for="item in yearOptions" :key="item" :value="item">{{ item }}</option>
          </select>

          <!-- Date range preset (non-client) -->
          <select class="filter-select" v-if="!currentUser.u.is_client" v-model="dateRageType"
            @change="changeDateRange()">
            <option value="today">Today</option>
            <option value="this_week">This Week</option>
            <option value="last_week">Last Week</option>
            <option value="this_month">This Month</option>
            <option value="last_month">Last Month</option>
            <option value="last_3_month">Last 3 Months</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
            <option value="custom">Custom</option>
          </select>

          <!-- Date from / to -->
          <input type="date" class="filter-date" v-model="date_from" @change="change_date"
            @keypress.enter="appData()" />
          <input type="date" class="filter-date" v-model="date_to" @change="change_date" @keypress.enter="appData()" />

          <!-- Service Provider (admin) — type-and-select -->
          <div class="ts-wrap" v-if="currentUser.u.is_admin" :class="{ open: spOpen }"
            v-click-outside="closeSpDropdown">
            <div class="ts-field" @click="toggleSp">
              <i class="fa fa-building ts-icon"></i>
              <input class="ts-input" ref="spInput" :value="spOpen ? spSearch : spLabel"
                @input="spSearch = $event.target.value" @mousedown.prevent placeholder="All Service Providers" />
              <i v-if="serviceProviderOutlet !== 'all'" class="fa fa-times-circle ts-clear"
                @click.stop="clearSp()" title="Clear"></i>
              <i class="fa fa-chevron-down ts-arrow" :class="{ 'ts-arrow--open': spOpen }"></i>
            </div>
            <div class="ts-menu" v-if="spOpen">
              <div class="ts-opt" :class="{ 'ts-opt--sel': serviceProviderOutlet === 'all' }"
                @mousedown.prevent="selectSp('all', 'All Service Providers')">All Service Providers</div>
              <div class="ts-opt" v-for="(c, i) in filteredSp" :key="i"
                :class="{ 'ts-opt--sel': serviceProviderOutlet === c.id }" @mousedown.prevent="selectSp(c.id, c.name)">
                {{ c.name }}</div>
              <div class="ts-empty" v-if="!filteredSp.length && spSearch">No matches</div>
            </div>
          </div>

          <!-- Location — type-and-select -->
          <div class="ts-wrap" :class="{ open: locOpen }" v-click-outside="closeLocDropdown">
            <div class="ts-field" @click="toggleLoc">
              <i class="fa fa-map-marker-alt ts-icon"></i>
              <input class="ts-input" ref="locInput" :value="locOpen ? locSearch : locLabel"
                @input="locSearch = $event.target.value" @mousedown.prevent placeholder="All Locations" />
              <i v-if="serviceOutlet !== 'all'" class="fa fa-times-circle ts-clear"
                @click.stop="clearLoc()" title="Clear"></i>
              <i class="fa fa-chevron-down ts-arrow" :class="{ 'ts-arrow--open': locOpen }"></i>
            </div>
            <div class="ts-menu" v-if="locOpen">
              <div class="ts-opt" :class="{ 'ts-opt--sel': serviceOutlet === 'all' }"
                @mousedown.prevent="selectLoc('all', 'All Locations')">All Locations</div>
              <div class="ts-opt" v-for="(c, i) in filteredLoc" :key="i"
                :class="{ 'ts-opt--sel': serviceOutlet === c.id }" @mousedown.prevent="selectLoc(c.id, c.name)">{{
                  c.name }}</div>
              <div class="ts-empty" v-if="!filteredLoc.length && locSearch">No matches</div>
            </div>
          </div>

          <!-- Service Type (admin) -->
          <select class="filter-select" v-if="currentUser.u.is_admin" v-model="serviceType"
            @change="selectedServiceType()">
            <option value="all">All Service Types</option>
            <option v-for="(c, i) in getServiceCodes" :key="i" :value="c.id">{{ c.service_name }}</option>
          </select>

          <!-- Service -->
          <select class="filter-select" v-model="service">
            <option value="all">All Services</option>
            <option v-for="(c, i) in getServices" :key="i" :value="c.id">{{ c.name }}</option>
          </select>

          <!-- Transmit Status -->
          <select class="filter-select" v-model="transmit_status">
            <option value="all">All Statuses</option>
            <option value="000">Draft</option>
            <option value="100">Ready To Transmit</option>
            <option value="200">Transmitted / Completed</option>
            <option value="300">Submitted To Server</option>
            <option value="error">Error</option>
          </select>

          <!-- Display deleted -->
          <select class="filter-select" v-model="display_deleted">
            <option value="all">Display All</option>
            <option value="False">Active</option>
            <option value="True">Deleted</option>
          </select>

          <!-- User (transmitted/updated by) — type-and-select -->
          <div class="ts-wrap" :class="{ open: userOpen }" v-click-outside="closeUserDropdown">
            <div class="ts-field" @click="toggleUser">
              <i class="fa fa-user ts-icon"></i>
              <input class="ts-input" ref="userInput" :value="userOpen ? userSearch : userLabel"
                @input="userSearch = $event.target.value" @mousedown.prevent placeholder="All Users" />
              <i v-if="updated_by !== 'all'" class="fa fa-times-circle ts-clear"
                @click.stop="clearUser()" title="Clear"></i>
              <i class="fa fa-chevron-down ts-arrow" :class="{ 'ts-arrow--open': userOpen }"></i>
            </div>
            <div class="ts-menu" v-if="userOpen">
              <div class="ts-opt" :class="{ 'ts-opt--sel': updated_by === 'all' }"
                @mousedown.prevent="selectUser('all')">All Users</div>
              <div class="ts-opt" v-for="(u, i) in filteredUsers" :key="i"
                :class="{ 'ts-opt--sel': updated_by === u.id }" @mousedown.prevent="selectUser(u.id)">
                {{ u.username }}</div>
              <div class="ts-empty" v-if="!filteredUsers.length && userSearch">No matches</div>
            </div>
          </div>

          <button class="btn-search" @click="advSearch()">
            <i class="fa fa-search"></i> Search
          </button>
        </div>
      </div>

      <!-- Legend (AppType only) -->
      <div class="legend-bar" v-if="AppType">
        <span class="legend-item"><span class="legend-dot dot-deleted"></span> Deleted</span>
        <span class="legend-item"><span class="legend-dot dot-transmitted"></span> Transmitted / Final</span>
      </div>

      <!-- Table -->
      <div class="table-wrap">

        <div class="state-box" v-if="getLoadingData">
          <i class="fa fa-spinner fa-spin"></i>
          Loading…
        </div>

        <div class="state-box" v-else-if="enrollments.length === 0">
          <i class="fa fa-inbox"></i>
          No enrollment records found
        </div>

        <table class="enr-table" v-else>
          <thead>
            <tr>
              <th>Date / Enr # / App #</th>
              <th>Applicant</th>
              <th>Location / Transmitted By</th>
              <th class="col-center">Prints</th>
              <th class="col-center">Resubmit</th>
              <th class="col-center">AHCA</th>
              <th>Status</th>
              <th class="col-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in enrollments" :key="index" :class="rowClass(item)">
              <td>
                <div class="cell-date">{{ item.enroll_date || dateFormat(item.created_at) }}</div>
                <div class="cell-enr cell-enr--link" @click.stop="openEnrollmentDetail(item.id, index)">ENR #{{ item.id
                  }}</div>
                <div class="cell-app">APP #{{ item.appointment_id }}</div>
              </td>
              <td>
                <div class="cell-applicant">{{ item.applicant || (item.fname + ' ' + item.mname + ' ' + item.lname) }}
                </div>
                <div class="cell-tcn">
                  <span>{{ item.tcn || '—' }}</span>
                  <button v-if="item.tcn" class="btn-copy-tcn" :title="copiedTcn === item.tcn ? 'Copied!' : 'Copy TCN'"
                    @click.stop="copyTcn(item.tcn)">
                    <i :class="copiedTcn === item.tcn ? 'fa fa-check' : 'fa fa-copy'"></i>
                  </button>
                </div>
                <div class="cell-service">{{ item.service_name }}</div>
              </td>
              <td>
                <div class="cell-location">{{ item.originating_location_name }}</div>
                <div class="cell-transmitted-by" v-if="isTransmitted(item)">{{ item.transmitted_by ||
                  item.updated_by_user }}</div>
              </td>
              <td class="col-center td-muted">{{ item.print_count }}</td>
              <td class="col-center td-muted">{{ item.resubmit_count }}</td>
              <td class="col-center">
                <template v-if="item.service_type === 'fdle'">
                  <span v-if="item.acha_submit_status === '300'" class="badge-status badge-green">
                    <i v-if="item.acha_response && item.acha_response.IsSuccessful === 'true'" class="fa fa-check"></i>
                    Submitted
                  </span>
                  <span v-else class="badge-status badge-grey">Not Submitted</span>
                </template>
                <span v-else class="td-empty">—</span>
              </td>
              <td>
                <span :class="['badge-transmit', transmitBadgeClass(item)]">{{ transmitLabel(item) }}</span>
              </td>
              <td class="col-center" @click.stop>
                <div class="action-wrap" :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)" :ref="`dropdown-${index}`">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :style="openIndex === index ? menuStyle : null">
                    <div class="menu-item blue" @click.stop="openEnrollmentDetail(item.id, index)">
                      <i class="fa fa-eye"></i> View
                    </div>
                    <div class="menu-item divider"></div>
                    <router-link class="menu-item teal"
                      :to="{ name: 'client.storeforward.tcn.pdf', params: { tcn: item.tcn, id: item.id } }"
                      @click.native.stop>
                      <i class="fa fa-print"></i> Print
                    </router-link>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="pagination.total_page > 1">
        <span class="pg-info">
          Page {{ pagination.current_page }} of {{ pagination.total_page }}
          <span v-if="pagination.total_records"> · {{ pagination.total_records }} records</span>
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="firstPage()">
            <i class="fa fa-angle-double-left"></i>
          </button>
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="previousPage()">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p === pagination.current_page }"
            @click="selectedPage(p)">{{ p }}</button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="nextPage()">
            <i class="fa fa-angle-right"></i>
          </button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="lastPage()">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  FETCH_CLIENT_ENROLLMENT,
  FETCH_CLIENTS,
  FETCH_SERVICES,
  FETCH_ENROLLMENT,
  FETCH_MASTER_COMPANIES,
  ENROLLMENT_LOGS,
  DOWNLOAD_CLIENT_ENROLLMENT,
  FETCH_SERVICES_CLIENTS,
  FETCH_SERVICE_CODES,
  FETCH_ENROLLMENT_UPDATED_BY_USERS
} from "@/core/services/store/actions.type";
import { SET_SERVICES, SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import enrollmentDetailModal from "@/components/frontend/modal/enrollmentdetail";
import JsonExcel from "vue-json-excel";

export default {
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  components: {
    enrollmentDetailModal,
    downloadExcel: JsonExcel
  },
  props: {
    AppType: { type: Boolean, default: true },
    DashType: { type: String, default: "appointment_list" }
  },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getServices", "getSpClients", "getServiceCodes"]),
    filteredSp() {
      const q = this.spSearch.toLowerCase();
      return (this.getClients || []).filter(c => !q || c.name.toLowerCase().includes(q));
    },
    filteredLoc() {
      const src = this.currentUser.u.is_admin ? (this.getSpClients || []) : (this.getClients || []);
      const q = this.locSearch.toLowerCase();
      return src.filter(c => !q || c.name.toLowerCase().includes(q));
    },
    spLabel() {
      if (this.serviceProviderOutlet === 'all') return '';
      const found = (this.getClients || []).find(c => c.id === this.serviceProviderOutlet);
      return found ? found.name : '';
    },
    locLabel() {
      if (this.serviceOutlet === 'all') return '';
      const src = this.currentUser.u.is_admin ? (this.getSpClients || []) : (this.getClients || []);
      const found = src.find(c => c.id === this.serviceOutlet);
      return found ? found.name : '';
    },
    filteredUsers() {
      const q = this.userSearch.toLowerCase();
      return (this.updatedByUsers || []).filter(u => !q || u.username.toLowerCase().includes(q));
    },
    userLabel() {
      if (this.updated_by === 'all') return '';
      const found = (this.updatedByUsers || []).find(u => u.id === this.updated_by);
      return found ? found.username : '';
    },
    visiblePages() {
      const pages = [];
      const cur = this.pagination.current_page;
      const total = this.pagination.total_page;
      for (let i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  filters: {
    toFixedTwoDigit(amount) { return parseFloat(amount).toFixed(2); }
  },
  data() {
    return {
      loadingMessage: "",
      generateReport: false,
      downloadData: [],
      dateRageType: "custom",
      enrollmentDetailModalShow: false,
      openIndex: null,
      menuStyle: null,
      json_fields: {
        Date: "enroll_date",
        "Enrollment No": "id",
        "Appointment No": "appointment_id",
        Applicant: "applicant",
        TCN: "tcn",
        Service: "service_name",
        Location: "client_name",
        Status: {
          field: "transmit_status",
          callback: value => {
            if (value.transmit_status === "000" || value.transmit_status === "100" || value.transmit_status === "400") return "Draft";
            if ((value.transmit_status === "200" || value.transmit_status === "500") && value.service_type === "fingerprintcard") return "Final";
            if ((value.transmit_status === "200" || value.transmit_status === "500") && value.service_type !== "fingerprintcard") return "Ready To Transmit";
            if (value.transmit_status === "300" || value.transmit_status === "600") return "Transmitted";
            return "";
          }
        },
        "Transmit by": "transmitted_by"
      },
      json_meta: [[{ key: "charset", value: "utf-8" }]],
      getLoadingData: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Enrollment List", route: "" }
      ],
      displayLogs: true,
      service: "all",
      serviceType: "all",
      serviceProviderOutlet: "all",
      serviceOutlet: "all",
      dateRageYear: this.$moment(new Date()).year(),
      todays_date: this.$moment(new Date()).format("MM-DD-YYYY"),
      date_from: this.$moment(new Date()).format("YYYY-MM-DD"),
      date_to: this.$moment(new Date()).add(7, "days").format("YYYY-MM-DD"),
      status: "all",
      yearOptions: [],
      payment_status: "all",
      transmit_status: "all",
      resubmit_status: "all",
      display_deleted: "all",
      updated_by: "all",
      updatedByUsers: [],
      enrollments: [],
      header: ["Enrollment Reports"],
      pagination: {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 15,
        received_per_page_data: 15
      },
      selectedAppId: 0,
      enrollmentData: {},
      currentIndex: -1,
      loadingData: false,
      hasData: false,
      msg: "",
      search_text: "",
      key: 0,
      spOpen: false,
      spSearch: "",
      locOpen: false,
      locSearch: "",
      userOpen: false,
      userSearch: "",
      copiedTcn: null
    };
  },
  mounted() {
    let year = 2021;
    const this_year = this.$moment(new Date()).year();
    while (this_year >= year) { this.yearOptions.push(year++); }

    this.$store.dispatch(FETCH_MASTER_COMPANIES);
    this.$store.dispatch(FETCH_CLIENTS);
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);

    const saved = this.loadFilters();
    if (saved) {
      this.dateRageType = saved.dateRageType ?? this.dateRageType;
      this.dateRageYear = saved.dateRageYear ?? this.dateRageYear;
      this.date_from = saved.date_from ?? this.date_from;
      this.date_to = saved.date_to ?? this.date_to;
      this.service = saved.service ?? "all";
      this.serviceOutlet = saved.serviceOutlet ?? (this.currentUser.u.is_client ? "self" : "all");
      this.serviceProviderOutlet = saved.serviceProviderOutlet ?? "all";
      this.serviceType = saved.serviceType ?? "all";
      this.transmit_status = saved.transmit_status ?? "all";
      this.display_deleted = saved.display_deleted ?? "all";
      this.updated_by = saved.updated_by ?? "all";
      this.search_text = saved.search_text ?? "";
      if (this.serviceOutlet !== "all") {
        this.$store.dispatch(FETCH_SERVICES, { location: this.serviceOutlet, sp: this.serviceProviderOutlet });
      } else {
        this.$store.commit(SET_SERVICES, []);
      }
      if (this.serviceProviderOutlet !== "all") {
        this.$store.dispatch(FETCH_SERVICES_CLIENTS, this.serviceProviderOutlet);
      }
    } else {
      this.$store.commit(SET_SERVICES, []);
      this.serviceOutlet = this.currentUser.u.is_client ? "self" : "all";
    }

    // Route params override saved filters (e.g. dashboard shortcut links)
    const rParams = this.$route.params;
    if (rParams) {
      if (rParams.service_id) { if (this.currentUser.u.is_admin) this.serviceType = rParams.service_id; else this.service = rParams.service_id; }
      if (rParams.service_status) this.transmit_status = rParams.service_status;
      if (rParams.start_date) this.date_from = rParams.start_date;
      if (rParams.end_date) this.date_to = rParams.end_date;
    }
    this.appData();

    if (!this.AppType) {
      this.columns = this.DashType === "today"
        ? [{ name: "App_no", label: "App No." }, { name: "applicant", label: "Applicant" }, { name: "Service/location", label: "Service/Location" }]
        : [{ name: "date", label: "Date" }, { name: "App_no", label: "App No." }, { name: "applicant", label: "Applicant" }, { name: "Service/location", label: "Service/Location" }];
    }
    if (this.currentUser.u.is_admin) this.$store.dispatch(FETCH_SERVICE_CODES);
    this.loadUpdatedByUsers();

    document.addEventListener("click", this.closeDropdown);
    window.addEventListener("scroll", this.closeDropdown, true);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
    window.removeEventListener("scroll", this.closeDropdown, true);
  },
  methods: {
    dateFormat(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY");
    },
    rowClass(item) {
      if (item.is_deleted) return "row-deleted";
      const ts = item.transmit_status;
      const fp = item.service_type === "fingerprintcard";
      if ((ts === "600" || ts === "300") || ((ts === "200" || ts === "500") && fp)) return "row-transmitted";
      return "";
    },
    transmitLabel(item) {
      const ts = item.transmit_status;
      const fp = item.service_type === "fingerprintcard";
      if ((ts === "200" || ts === "500") && !fp) return "Ready To Transmit";
      if ((ts === "200" || ts === "500") && fp) return "Final";
      if ((ts === "300" || ts === "600") && fp) return "Final";
      if ((ts === "300" || ts === "600") && !fp) return "Transmitted";
      if (ts === "100" || ts === "400") return "Draft";
      return "—";
    },
    transmitBadgeClass(item) {
      const ts = item.transmit_status;
      const fp = item.service_type === "fingerprintcard";
      if (ts === "300" || ts === "600") return "badge-green";
      if ((ts === "200" || ts === "500") && !fp) return "badge-blue";
      if ((ts === "200" || ts === "500") && fp) return "badge-green";
      if (ts === "100" || ts === "400") return "badge-grey";
      return "badge-grey";
    },
    isTransmitted(item) {
      const ts = item.transmit_status;
      const fp = item.service_type === "fingerprintcard";
      // For Fingerprint Card / FD258, "Final" (200/500) is the same terminal
      // state as "Transmitted" (300/600) for other service types -- there's
      // no separate transmit step -- so show Transmitted By there too.
      if (fp) return ts === "200" || ts === "500" || ts === "300" || ts === "600";
      return ts === "300" || ts === "600";
    },
    search() {
      this.pagination = { total_records: 0, total_page: 0, current_page: 1, per_page_data: 15, received_per_page_data: 15 };
      this.appData();
    },
    advSearch() { this.search_text = ""; this.search(); },
    closeModal() { this.enrollmentDetailModalShow = false; },
    reTableReload(index) { this.enrollments[index].payment_status = "Refund"; },
    openEnrollmentDetail(enrollmentId, index) {
      this.openIndex = null;
      this.currentIndex = index;
      this.enrollmentDetailModalShow = true;
      this.selectedAppId = enrollmentId;
      this.loadingData = true;
      this.$store.dispatch(ENROLLMENT_LOGS, { enrollment_id: enrollmentId });
      this.$store.dispatch(FETCH_ENROLLMENT, { enrollment_id: enrollmentId })
        .then(res => {
          this.enrollmentData = res.data;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.displayLogs = true;
          this.key += 1;
        })
        .catch(() => { this.loadingData = false; });
    },
    toggleDropdown(index, event) {
      if (this.openIndex === index) {
        this.openIndex = null;
        this.menuStyle = null;
        return;
      }
      this.openIndex = index;
      this.$nextTick(() => {
        const rect = event.currentTarget.getBoundingClientRect();
        const menuH = 100;
        const rightOffset = window.innerWidth - rect.right;
        if (window.innerHeight - rect.bottom < menuH + 8) {
          this.menuStyle = { position: 'fixed', bottom: (window.innerHeight - rect.top + 4) + 'px', top: 'auto', right: rightOffset + 'px' };
        } else {
          this.menuStyle = { position: 'fixed', top: (rect.bottom + 4) + 'px', bottom: 'auto', right: rightOffset + 'px' };
        }
      });
    },
    closeDropdown() {
      this.openIndex = null;
      this.menuStyle = null;
    },
    copyTcn(tcn) {
      navigator.clipboard.writeText(tcn).then(() => {
        this.copiedTcn = tcn;
        setTimeout(() => { this.copiedTcn = null; }, 1800);
      });
    },
    openSp() { this.spOpen = true; this.spSearch = ""; this.$nextTick(() => this.$refs.spInput && this.$refs.spInput.focus()); },
    toggleSp() { this.spOpen ? this.closeSpDropdown() : this.openSp(); },
    closeSpDropdown() { this.spOpen = false; this.spSearch = ""; },
    selectSp(id) {
      this.serviceProviderOutlet = id;
      this.spOpen = false;
      this.spSearch = "";
      this.loadServicesProvider();
    },
    clearSp() { this.selectSp("all"); },
    openLoc() { this.locOpen = true; this.locSearch = ""; this.$nextTick(() => this.$refs.locInput && this.$refs.locInput.focus()); },
    toggleLoc() { this.locOpen ? this.closeLocDropdown() : this.openLoc(); },
    closeLocDropdown() { this.locOpen = false; this.locSearch = ""; },
    selectLoc(id) {
      this.serviceOutlet = id;
      this.locOpen = false;
      this.locSearch = "";
      this.loadServices();
    },
    clearLoc() { this.selectLoc("all"); },
    openUser() { this.userOpen = true; this.userSearch = ""; this.$nextTick(() => this.$refs.userInput && this.$refs.userInput.focus()); },
    toggleUser() { this.userOpen ? this.closeUserDropdown() : this.openUser(); },
    closeUserDropdown() { this.userOpen = false; this.userSearch = ""; },
    selectUser(id) {
      this.updated_by = id;
      this.userOpen = false;
      this.userSearch = "";
    },
    clearUser() { this.selectUser("all"); },
    changeDateRange() {
      const isNotNumber = isNaN(this.dateRageType);
      if (isNotNumber) {
        switch (this.dateRageType) {
          case "today": this.date_from = moment().format("YYYY-MM-DD"); this.date_to = moment().format("YYYY-MM-DD"); break;
          case "this_week": this.date_from = moment().startOf("week").format("YYYY-MM-DD"); this.date_to = moment().endOf("week").format("YYYY-MM-DD"); break;
          case "last_week": this.date_from = moment().subtract(1, "weeks").startOf("week").format("YYYY-MM-DD"); this.date_to = moment().subtract(1, "weeks").endOf("week").format("YYYY-MM-DD"); break;
          case "this_month": this.date_from = moment().startOf("month").format("YYYY-MM-DD"); this.date_to = moment().endOf("month").format("YYYY-MM-DD"); break;
          case "last_month": this.date_from = moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"); this.date_to = moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"); break;
          case "last_3_month": this.date_from = moment().subtract(3, "months").startOf("month").format("YYYY-MM-DD"); this.date_to = moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"); break;
          case "custom": break;
        }
        this.dateRageYear = this.$moment(new Date()).year();
      } else {
        const y = this.dateRageYear;
        this.date_from = moment().set("year", parseInt(y)).set("month", parseInt(this.dateRageType) - 1).startOf("month").format("YYYY-MM-DD");
        this.date_to = moment().set("year", parseInt(y)).set("month", parseInt(this.dateRageType) - 1).endOf("month").format("YYYY-MM-DD");
      }
    },
    change_date() { this.dateRageType = "custom"; },
    changeYear() {
      this.dateRageType = "custom";
      this.date_from = moment().set("year", parseInt(this.dateRageYear)).set("month", 0).startOf("month").format("YYYY-MM-DD");
      this.date_to = moment().set("year", parseInt(this.dateRageYear)).set("month", 0).endOf("month").format("YYYY-MM-DD");
    },
    selectedPage(n) { this.pagination.current_page = n; this.appData(); },
    nextPage() { this.pagination.current_page++; this.appData(); },
    lastPage() { this.pagination.current_page = this.pagination.total_page; this.appData(); },
    firstPage() { this.pagination.current_page = 1; this.appData(); },
    previousPage() { this.pagination.current_page--; this.appData(); },
    loadServicesProvider() {
      this.serviceOutlet = "all"; this.service = "all";
      this.$store.dispatch(FETCH_SERVICES_CLIENTS, this.serviceProviderOutlet);
      if (this.serviceType === "all" && this.currentUser.u.is_admin && this.serviceProviderOutlet !== "all") {
        this.$store.dispatch(FETCH_SERVICES, { location: this.serviceOutlet, sp: this.serviceProviderOutlet });
      } else {
        this.$store.commit(SET_SERVICES, []);
      }
      // User list is scoped to the selected Service Provider for admin -- All
      // Service Providers shows everyone, a single SP shows only its users.
      this.updated_by = "all";
      this.loadUpdatedByUsers();
    },
    loadUpdatedByUsers() {
      this.$store.dispatch(FETCH_ENROLLMENT_UPDATED_BY_USERS, { service_provider: this.serviceProviderOutlet })
        .then(res => { this.updatedByUsers = res.data || []; })
        .catch(() => {});
    },
    loadServices() {
      this.service = "all";
      if (this.serviceOutlet === "all") {
        this.$store.commit(SET_SERVICES, []);
        return;
      }
      if (this.currentUser.u.is_admin && this.serviceType === "all") {
        this.$store.dispatch(FETCH_SERVICES, { location: this.serviceOutlet, sp: this.serviceProviderOutlet });
      } else {
        this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
      }
    },
    selectedServiceType() {
      if (this.serviceType !== "all") {
        if (this.currentUser.u.is_admin) { this.service = "all"; this.$store.commit(SET_SERVICES, []); }
      } else {
        this.$store.dispatch(FETCH_SERVICES, { location: this.serviceOutlet, sp: this.serviceProviderOutlet });
      }
    },
    async fetchData() {
      this.header = [
        "Enrollment Reports",
        "Date: " + this.date_from + " to " + this.date_to,
        this.serviceOutlet !== "all" ? "Location: " + (this.getClients.find(c => c.id === this.serviceOutlet) || {}).name : "Location: All",
        this.service !== "all" ? "Service: " + (this.getServices.find(s => s.id === this.service) || {}).name : "Service: All",
        this.transmit_status !== "all" ? "Transmit Status: " + this.transmitLabel({ transmit_status: this.transmit_status, service_type: "" }) : "Transmit Status: All"
      ];
      const res = await this.$store.dispatch(DOWNLOAD_CLIENT_ENROLLMENT, this.buildPayload());
      return res.data;
    },
    startDownload() { this.generateReport = true; this.loadingMessage = "Please wait…<br>Your report is being generated"; },
    finishDownload() { this.generateReport = false; this.loadingMessage = ""; },
    buildPayload() {
      const base = {
        service: this.service,
        service_outlet: this.serviceOutlet,
        date_from: this.date_from,
        date_to: this.date_to,
        type: this.currentUser.u.is_client ? "c" : "sp",
        status: this.status,
        payment_status: this.payment_status,
        transmit_status: this.transmit_status,
        resubmit_status: this.resubmit_status,
        page: this.pagination.current_page,
        search_text: this.search_text,
        display_deleted: this.display_deleted,
        updated_by: this.updated_by,
        dtype: "appointment_list"
      };
      if (this.currentUser.u.is_admin) Object.assign(base, { service_provider: this.serviceProviderOutlet, service_type_code: this.serviceType });
      return base;
    },
    saveFilters() {
      window.localStorage.setItem("sf_filters", JSON.stringify({
        dateRageType: this.dateRageType,
        dateRageYear: this.dateRageYear,
        date_from: this.date_from,
        date_to: this.date_to,
        service: this.service,
        serviceOutlet: this.serviceOutlet,
        serviceProviderOutlet: this.serviceProviderOutlet,
        serviceType: this.serviceType,
        transmit_status: this.transmit_status,
        display_deleted: this.display_deleted,
        updated_by: this.updated_by,
        search_text: this.search_text,
      }));
    },
    loadFilters() {
      try {
        const raw = window.localStorage.getItem("sf_filters");
        return raw ? JSON.parse(raw) : null;
      } catch { return null; }
    },
    appData() {
      this.enrollments = [];
      this.getLoadingData = true;
      this.saveFilters();
      const data = this.buildPayload();
      this.$store.dispatch(FETCH_CLIENT_ENROLLMENT, data)
        .then(res => {
          this.getLoadingData = false;
          this.enrollments = res.data;
          this.pagination.total_records = res.total_record;
          this.pagination.total_page = res.page_range;
          this.pagination.received_per_page_data = res.data.length;
          this.pagination.per_page_data = 15;
        })
        .catch(err => { this.getLoadingData = false; this.msg = err.error; });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$green: #276749;
$orange: #F58020;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

/* Processing overlay */
.processing-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(13, 27, 62, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.processing-card {
  background: #fff;
  border-radius: 14px;
  padding: 32px 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(13, 27, 62, 0.18);

  i {
    font-size: 28px;
    color: $blue;
    margin-bottom: 12px;
    display: block;
  }
}

.processing-title {
  font-size: 13px;
  color: $dark;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Panel */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: clip;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 10px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  background: #eef0f6;
  border-radius: 10px;
  padding: 1px 7px;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

.btn-export {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1.5px solid $green;
  background: transparent;
  color: $green;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;

  &:hover {
    background: #f0faf4;
  }
}

/* Toolbar */
.toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
}

.toolbar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.toolbar-filters {
  gap: 6px;
}

.search-box {
  position: relative;
  flex: 1;
  min-width: 200px;
  max-width: 320px;

  i {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #a0aab8;
    font-size: 12px;
    pointer-events: none;
  }

  input {
    box-sizing: border-box;
    width: 100%;
    height: 36px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 30px 0 30px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    outline: none;
    background: #fff;
    transition: border-color 0.2s;

    &::placeholder {
      color: #b0bac9;
    }

    &:focus {
      border-color: $blue;
      box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
    }
  }
}

.search-clear {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #a0aab8;
  cursor: pointer;
  font-size: 11px;
  padding: 0;

  &:hover {
    color: $dark;
  }
}

.filter-select {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 28px 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
  appearance: none;
  outline: none;
  cursor: pointer;
  // width: 170px;
  transition: border-color 0.2s;
  margin: 0 0 0 0;

  &:focus {
    border-color: $blue;
  }
}

.filter-date {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: $blue;
  }
}

.btn-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;

  i {
    font-size: 11px;
  }

  &:hover {
    opacity: 0.9;
  }
}

/* Legend */
.legend-bar {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 8px 20px;
  border-bottom: 1px solid #f0f3fa;
  background: #fafbfd;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #6b7280;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}

.dot-deleted {
  background: #fca5a5;
}

.dot-transmitted {
  background: #86efac;
}

/* Table */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 520px;
}

.state-box {
  text-align: center;
  padding: 48px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 28px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}

.enr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;
  table-layout: auto;

  thead tr {
    background: #fff;
    border-bottom: 2px solid #eef0f8;
    position: sticky;
    top: 0;
    z-index: 2;

    th {
      padding: 18px 12px;
      text-align: left;
      font-size: 11px;
      font-weight: 700;
      color: #7a8499;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      white-space: nowrap;

      &.col-center {
        text-align: center;
      }
    }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child {
      border-bottom: none;
    }

    &:hover td {
      background: #f8fbff;
    }

    td {
      padding: 18px 12px;
      color: $dark;
      vertical-align: middle;
      white-space: normal;
      word-break: break-word;

      &.col-center {
        text-align: center;
      }
    }
  }
}

/* Row status colors */
.row-deleted td {
  background: #fff5f5 !important;
}

.row-deleted td:first-child {
  border-left: 3px solid #f87171;
}

.row-transmitted td {
  background: #f0fdf4 !important;
}

.row-transmitted td:first-child {
  border-left: 3px solid #4ade80;
}

.row-transmitted:hover td {
  background: #dcfce7 !important;
}

.td-date {
  font-size: 12px;
  color: #6b7280;
}

.td-muted {
  color: #6b7280;
}

.td-mono {
  font-family: 'Courier New', monospace;
  font-size: 12px;
}

.cell-applicant {
  font-weight: 500;
  color: $dark;
}

.cell-tcn {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'Courier New', monospace;
  font-size: 11px;
  color: #6b7280;
  margin-top: 3px;
}

.btn-copy-tcn {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #dde2ec;
  border-radius: 4px;
  background: #f7f9fc;
  color: #a0aab8;
  font-size: 9px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  padding: 0;

  &:hover {
    border-color: $blue;
    color: $blue;
    background: #eef2fb;
  }

  .fa-check {
    color: #276749;
  }
}

.cell-service {
  font-size: 11px;
  color: #6b7280;
  margin-top: 3px;
}

.cell-location {
  color: $dark;
}

.cell-transmitted-by {
  font-size: 11px;
  color: #6b7280;
  margin-top: 3px;
}

.td-empty {
  color: #c8d0dc;
}

.col-enr {
  font-weight: 600;
  color: $dark;
}

.cell-date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.cell-enr {
  font-size: 12px;
  font-weight: 700;
  color: $dark;
  margin-top: 3px;
  white-space: nowrap;
}

.cell-enr--link {
  cursor: pointer;

  &:hover {
    color: $blue;
    text-decoration: underline;
  }
}

.cell-app {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
}

/* Badges */
.badge-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;

  i {
    font-size: 9px;
  }

  &.badge-green {
    background: #dcfce7;
    color: #166534;
  }

  &.badge-grey {
    background: #f3f4f6;
    color: #6b7280;
  }
}

.badge-transmit {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;

  &.badge-green {
    background: #dcfce7;
    color: #166534;
  }

  &.badge-blue {
    background: #dbeafe;
    color: #1d4ed8;
  }

  &.badge-grey {
    background: #f3f4f6;
    color: #6b7280;
  }
}

/* Action dropdown */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover {
      background: #eef2fb;
      color: #185FA5;
      border-color: #c5d4f0;
    }
  }

  .action-menu {
    display: none;
    position: fixed;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 130px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 9999;
    overflow: hidden;

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      color: #2d3748;
      cursor: pointer;
      text-decoration: none;
      transition: background 0.15s;

      i {
        width: 14px;
        font-size: 12px;
      }

      &:hover {
        background: #f8fbff;
      }

      &.blue {
        color: #185FA5;

        i {
          color: #185FA5;
        }

        &:hover {
          background: #eef2fb;
        }
      }

      &.teal {
        color: #276749;

        i {
          color: #276749;
        }

        &:hover {
          background: #f0fdf4;
        }
      }

      &.divider {
        border-top: 1px solid #f0f3fa;
        pointer-events: none;
        padding: 0;
        margin: 0;
      }
    }
  }

  &.open .action-menu {
    display: block;
  }
}

/* Pagination */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;
}

.pg-info {
  font-size: 12px;
  color: #7a8499;
}

.pg-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pg-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    border-color: $blue;
    color: $blue;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }

  &.active {
    background: $blue;
    border-color: $blue;
    color: #fff;
  }
}

/* ── Type-and-select ── */
.ts-wrap {
  position: relative;
  min-width: 170px;
  max-width: 220px;
}

.ts-field {
  display: flex;
  align-items: center;
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px;
  gap: 7px;
  cursor: pointer;
  transition: border-color 0.2s;

  .ts-wrap.open & {
    border-color: $blue;
    box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
  }
}

.ts-icon {
  font-size: 11px;
  color: #a0aab8;
  flex-shrink: 0;
}

.ts-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: transparent;
  min-width: 0;
  cursor: pointer;

  &::placeholder {
    color: #b0bac9;
  }
}

.ts-arrow {
  font-size: 10px;
  color: #a0aab8;
  flex-shrink: 0;
  transition: transform 0.2s;

  &--open {
    transform: rotate(180deg);
  }
}

.ts-clear {
  font-size: 13px;
  color: #a0aab8;
  flex-shrink: 0;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #e34c4c;
  }
}

.ts-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.1);
  z-index: 500;
  max-height: 220px;
  overflow-y: auto;
}

.ts-opt {
  padding: 8px 12px;
  font-size: 12px;
  color: $dark;
  cursor: pointer;
  transition: background 0.12s;

  &:hover {
    background: #f0f7fc;
  }

  &--sel {
    background: #eef7fb;
    color: $blue;
    font-weight: 600;
  }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
}
</style>
